export const MicroservicesBaseUrl = {
    //baseApiUrl: 'https://localhost:44331/',
    // baseApiUrl: 'https://vendortopay.in/vayanapg/',
    //    baseApiUrl: 'http://20.219.161.80:8091/',
    baseApiUrl: 'https://pgapi.v2pnonpa.vayana.com/',
    webBaseUrl: '*',
}
export const ApiType = {
    identityAPI: 'IdentityAPI',
    baseAPI: 'BaseAPI',
    genericAPI: 'GenericAPI',
}
export const AlertMessageType = {
    Error: 'error',
    Warning: 'warning',
    Success: 'success',
    Info: 'info',
}

export const EncKeys = {
    VayanaEncKey: '6fa979f20126cb08aa645a8f495f6d85',
    IV: '4512631236589784',
}
